'use client';

import type { View } from 'react-native';

import { useCallback, useEffect, useRef, useState } from 'react';

export type DropdownPosition = {
  top: number;
  right: number;
  left: number;
};

const useDropdownMenu = (visible: boolean = true) => {
  const ref = useRef<HTMLButtonElement | View>(null);

  const [dropdownPosition, setDropdownPosition] =
    useState<DropdownPosition | null>(null);

  const setDropdownItemCurrentPosition = useCallback(() => {
    if (!ref.current) {
      return;
    }

    if ('isConnected' in ref.current) {
      const elementBoundingClientRect = ref.current.getBoundingClientRect();
      const bodyBoundingClientRect = document.body.getBoundingClientRect();
      const x = elementBoundingClientRect.x - bodyBoundingClientRect.x;
      const { top, height, width } = elementBoundingClientRect;
      const windowWidth = bodyBoundingClientRect.width;
      setDropdownPosition({
        top: top + height,
        right: windowWidth - x - width,
        left: x,
      });
    }
  }, []);

  useEffect(() => {
    if (!visible) {
      return undefined;
    }
    window.addEventListener('resize', setDropdownItemCurrentPosition);

    setDropdownItemCurrentPosition();

    return () =>
      window.removeEventListener('resize', setDropdownItemCurrentPosition);
  }, [visible, setDropdownItemCurrentPosition]);

  return { ref, dropdownPosition, setDropdownItemCurrentPosition };
};

export default useDropdownMenu;
